<template>
    <div class="page">
        <ion-grid>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="search-view">
                <ion-col>
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="3">
                            <ion-label>Station Name</ion-label>
                            <div class="border-line-34 margin-top-10" >
                                <ion-input
                                class="form-input"
                                :class="displayInd == true ? 'readonly' : ''"
                                type="text"
                                id="stationName"
                                @input="stationName = $event.target.value"
                                maxlength="100"
                                :value = stationName
                                :readonly = "displayInd == true ? 'true' : false" 
                                ></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>Charger ID</ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input
                                class="form-input"
                                type="text"
                                id="serialNumber"
                                @input="serialNumber = $event.target.value"
                                maxlength="100"
                                ></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>Charger Type</ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-select
                                class="form-select select-mobile"
                                :value="chargerType"
                                @ionChange="chargerType = $event.target.value"
                                placeholder="Select Type"
                                interface="action-sheet"
                                >
                                <ion-select-option
                                    v-for="(type, index) in this.types"
                                    :value="type.id"
                                    :key="index"
                                >{{type.name}}</ion-select-option>
                                </ion-select>

                                <select
                                class="input-select select-web"
                                v-model="chargerType"
                                placeholder="Select Type"
                                >
                                <option
                                    v-for="(type, index) in this.types"
                                    :value="type.id"
                                    :key="index"
                                >{{ type.name }}</option>
                                </select>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>Status</ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-select
                                class="form-select select-mobile"
                                :value="status"
                                @ionChange="status = $event.target.value"
                                placeholder="Select Status"
                                interface="action-sheet"
                                >
                                <ion-select-option
                                    v-for="(status, index) in this.statuses"
                                    :value="status.id"
                                    :key="index"
                                >{{status.name}}</ion-select-option>
                                </ion-select>

                                <select
                                class="input-select select-web"
                                v-model="status"
                                placeholder="Select Status"
                                >
                                <option
                                    v-for="(status, index) in this.statuses"
                                    :value="status.id"
                                    :key="index"
                                >{{ status.name }}</option>
                                </select>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>From Date</ion-label>
                            <div class="date-picker-box margin-top-10 datepicker-web">
                                <datepicker
                                    class= "form-vue-picker"
                                    placeholder= "DD/MON/YYYY"
                                    inputFormat="dd/MMM/yyyy"
                                    v-model= "effectiveOn"
                                    :typeable= "true"
                                ></datepicker>
                                <span class="custom-calendar-icon">
                                <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                            <div class="border-line-34 margin-top-10 datepicker-mobile">
                                <!-- <div class="input-icon-calendar"> -->
                                <!-- <ion-datetime
                                    class="form-picker"
                                    placeholder="DD/MON/YYYY"
                                    displayFormat="YYYY, MM, DD"
                                    @ionChange="effectiveOn = $event.target.value"
                                ></ion-datetime> -->
                                <!-- </div> -->
                                <datepicker
                                    class= "form-picker"
                                    placeholder= "DD/MON/YYYY"
                                    inputFormat="MMM dd, yyyy"
                                    v-model= "effectiveOn"
                                    :typeable= "true"
                                ></datepicker>
                                <span class="input-icon-calendar">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>To Date</ion-label>
                            <div class="date-picker-box margin-top-10 datepicker-web">
                                <datepicker
                                    class= "form-vue-picker"
                                    placeholder= "DD/MON/YYYY"
                                    inputFormat="dd/MMM/yyyy"
                                    v-model= "lastEffectiveOn"
                                    :typeable= "true"
                                ></datepicker>
                                <span class="custom-calendar-icon">
                                <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                            <div class="border-line-34 margin-top-10 datepicker-mobile">
                                <!-- <div class="input-icon-calendar"> -->
                                <!-- <ion-datetime
                                    class="form-picker"
                                    placeholder="DD/MON/YYYY"
                                    displayFormat="YYYY, MM, DD"
                                    @ionChange="lastEffectiveOn = $event.target.value"
                                ></ion-datetime> -->
                                <datepicker
                                    class= "form-picker"
                                    placeholder= "DD/MON/YYYY"
                                    inputFormat="MMM dd, yyyy"
                                    v-model= "lastEffectiveOn"
                                    :typeable= "true"
                                ></datepicker>
                                <span class="input-icon-calendar">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                                <!-- </div> -->
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <br />
                            <ion-button class="btn-search margin-top-10" @click="searchChargerInstalls">Search</ion-button>
                            <ion-button class="btn-clear margin-top-10" @click="clearFields">
                                <ion-icon :icon="refresh"></ion-icon>
                            </ion-button>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="list-view">
                <ion-col>
                    <ion-row class="list-head">
                        <ion-col size="12" size-md="1">
                        <ion-label>Station ID</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1">
                        <ion-label>Charger ID</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>Station Name</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                        <ion-label>Charger Type</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>Last Effective Date</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>Status</ion-label>
                        </ion-col>
                    </ion-row>
                    <hr />

                    <ion-row
                        class="list-item"
                        v-for="(chargerInstall, index) in this.chargerInstalls"
                        :key="index"
                        >
                        <!-- Below code is commednted for station id need to display first then charger id -->
                        <!-- <ion-col size="12" size-md="1">
                            <ion-label class="ext-link" @click="viewChargerInstall(chargerInstall.id, chargerInstall.charger.id)">{{chargerInstall.charger.id}}</ion-label>
                        </ion-col> -->
                        <ion-col size="12" size-md="1">
                            <ion-label  class="ext-link" @click="viewChargerInstall(chargerInstall.id, chargerInstall.charger.id)">{{chargerInstall.station.id}}</ion-label>
                        </ion-col>
                         <ion-col size="12" size-md="1">
                            <ion-label>{{chargerInstall.charger.id}}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{chargerInstall.station.name}}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                        <ion-label>{{chargerInstall.charger.type.id}}</ion-label>
                        <!-- <ion-label>{{chargerInstall.charger.model}}</ion-label> -->
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{changeDateFormatWithoutTime(chargerInstall.effectiveTill)}}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label
                            v-bind:class="[{'active': chargerInstall.status.id == 'A'}, {'in-active': chargerInstall.status.id == 'I'}, {'retired': chargerInstall.status.id == 'R'}]"
                        >{{convertUppercase(chargerInstall.status.name)}}</ion-label>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="row-divider"></ion-row>
            <ion-row v-if="norecordsfound">
                <ion-col size="12" text-center class="pagination-info">
                <ion-label class="pagination-info">No records found for the selected filters</ion-label>
                </ion-col>
            </ion-row>
            <ion-row v-else>
                <ion-col size="12" size-md="5">
                    <ion-label
                        class="pagination-info"
                    >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
                </ion-col>
                <ion-col size="12" size-md="7" class="ion-text-right">
                    <div class="pagination">
                        <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
                        <a class="prev disabled" v-else>Prev</a>
                        <a
                        
                        v-for="page in this.pagesList"
                        :key="page"
                        v-bind:class="{'active': pageNo == page}"
                        @click="loadPage(page)"
                        >{{page}}</a>
                        <a
                        
                        class="next"
                        v-if="this.pageNo < this.totalPages"
                        @click="loadPage(pageNo + 1)"
                        >Next</a>
                        <a class="next disabled" v-else>Next</a>
                    </div>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="spinner">
        <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonButton, IonRow, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { EVCStationService } from "../../service/evcstation/stations.service";
import { EVChargerService } from "../../service/evcstation/charger.service";
import { EVCharger, EVChargerStatus, EVChargerType } from "../../entity/station/evcharger";
import { EVCStation } from "../../entity/location/evcstation";
import { EVCStationBayStatus } from "../../entity/station/evcbay";
import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import { refresh } from 'ionicons/icons';
import moment from "moment";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";

export default defineComponent ({
    name: 'chargers',
    components: {
        datepicker, IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonInput, IonButton, IonIcon, IonSpinner
    },
    data() {
        return {
            refresh,
            loaderTab: true,
            chargerInstalls: null,
            statuses: [],
            statusModels: [],
            types: [],
            typeModels: [],
            status: "",
            stationName: "",
            serialNumber: "",
            chargerType: "",
            // effectiveOn: new Date(),
            // lastEffectiveOn: new Date(),
            effectiveOn: "",
            lastEffectiveOn: "",
            norecordsfound: true,
            totalRecords: 0,
            pageRecords: 13,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            displayInd: false,
            stationId: ""
        }
    },
    async mounted() {
        try {
            let roleId = localStorage.getItem('user.roleId')
            if(roleId == 4) {
                let stationInfo = JSON.parse(localStorage.getItem('branchStationInfo'));
                this.displayInd = true;
                this.stationName = stationInfo.stationName;
                this.stationId = stationInfo.stationId;
                await this.searchChargerInstalls();
            }

            this.types = await new EVChargerService().chargerTypes();
            this.statuses = await new EVCStationService().installationStatuses();

            this.statusModels = [];
            this.statuses.forEach((status) => {
            this.statusModels.push({
                text: status.name,
                value: status.id,
            });
            });

            this.typeModels = [];
            this.types.forEach((type) => {
            this.typeModels.push({
                text: type.name,
                value: type.id,
            });
            });

            var page = localStorage.getItem("installationPage");
            if (page) {
                this.pageNo = Number(page);
            }
            var search = localStorage.getItem("installationSearch");
            
            // if (search && search.stationName != undefined) {
            if (search) {
                search = JSON.parse(search);
                this.stationName = search.stationName;
                this.serialNumber = search.serialNumber;
                document.getElementById("stationName").value = search.stationName;
                document.getElementById("serialNumber").value = search.serialNumber;
                this.chargerType = search.chargerType;
                // this.effectiveOn = search.effectiveOn;
                // this.lastEffectiveOn = search.lastEffectiveOn;
                this.effectiveOn = (search.effectiveOn != null && search.effectiveOn != "") ? new Date(search.effectiveOn) : null,
                this.lastEffectiveOn = (search.lastEffectiveOn != null && search.lastEffectiveOn != "") ? new Date(search.lastEffectiveOn) : null,
                
                this.status = search.status;
                
                await this.searchChargerInstalls();
            }
            this.loaderTab = false;
        } catch(error) {
            this.loaderTab = false;
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        }
        
    },
    methods: {
        changeDateFormat(dateValue) {
            return moment(dateValue).format('DD/MMM/YYYY HH:mm')
        },
        changeDateFormatWithoutTime(dateValue) {
        
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY')
            }
        
        },
        convertUppercase(value) {
            return value.toUpperCase()
        },
        addChargerInstall() {
            this.$router.push("/admin/chargerinstallations/bay");
        },
        viewChargerInstall(bayId, stationId) {
            let bayStationInfo = { bayId: bayId, stationId: stationId }
            localStorage.setItem("bayStationInfo", JSON.stringify(bayStationInfo))
            this.$router.push({
                name: "chargerInstallationView",
                params: { bayId: bayId, stationId: stationId },
            });
        },
        clearFields() {
            this.pageRecords = 13,
            this.pageNo = 1,
            this.stationName = null;
            this.serialNumber = null;
            document.getElementById("stationName").value = null;
            document.getElementById("serialNumber").value = null;
            this.chargerType = null;
            this.effectiveOn = null;
            this.lastEffectiveOn = null;
            this.status = null;

            localStorage.removeItem("installationSearch");
            localStorage.removeItem("installationPage");
            this.chargerInstalls = [];
            this.norecordsfound = true; //Modified by Swide on 2020-12-16 Bug#3 
        },
        async searchChargerInstalls() {
            // localStorage.setItem(
            //     "installationSearch",
            //     JSON.stringify({
            //     stationName: this.stationName,
            //     serialNumber: this.serialNumber,
            //     chargerType: this.chargerType,
            //     effectiveOn: this.effectiveOn,
            //     lastEffectiveOn: this.lastEffectiveOn,
            //     status: this.status,
            //     })
            // );
            // if(this.stationName || this.serialNumber || this.chargerType || this.status || this.effectiveOn || this.lastEffectiveOn) {
            //     this.pageRecords = 13,
            //     this.pageNo = 1
            // }
            let existingFilterData = JSON.parse(localStorage.getItem("installationSearch"))
            let searchFilterData = {
                stationName: this.stationName,
                serialNumber: this.serialNumber,
                chargerType: this.chargerType,
                // effectiveOn: this.effectiveOn,
                // lastEffectiveOn: this.lastEffectiveOn,
                effectiveOn: (this.effectiveOn != null && this.effectiveOn != "") ? new Date(this.effectiveOn) : null,
                lastEffectiveOn: (this.lastEffectiveOn != null && this.lastEffectiveOn != "") ? new Date(this.lastEffectiveOn) : null,
                status: this.status,
            }
            if(!this.areFiltersEqual(searchFilterData, existingFilterData)) {
                localStorage.setItem("installationSearch",JSON.stringify(searchFilterData));
                this.pageNo = 1;
                localStorage.setItem('installationPage', this.pageNo);
            } else {
                let pageNo = localStorage.getItem('installationPage');
                if(pageNo) {
                    this.pageNo = pageNo;
                } else {
                    this.pageNo = 1;
                }
            }
            localStorage.setItem("installationSearch",JSON.stringify(searchFilterData));

            if (
                this.effectiveOn &&
                this.lastEffectiveOn &&
                new Date(this.effectiveOn) > new Date(this.lastEffectiveOn)
            ) {
                new ToastUtils().presentToast(
                "Please select correct date range. From date should less than To date"
                );
                this.chargerInstalls = [];
            } else {
                try {
                    this.loaderTab = true;
                    let result = await new EVCStationService().baysAtPageByPaginatedWithSizeMatchingQuery(
                    this.pageNo,
                    this.pageRecords,
                    this.stationId != "" ? this.stationId : "",
                    {
                        station: { name: this.stationName },
                        charger: { id: this.serialNumber },
                        chargerType: new EVChargerType(this.chargerType),
                        effectiveBetween: {
                        // from: this.effectiveOn ? new Date(this.effectiveOn) : null,
                        // to: this.lastEffectiveOn ? new Date(this.lastEffectiveOn) : null,
                        from: (this.effectiveOn != null && this.effectiveOn != "") ? new Date(this.effectiveOn) : null,
                        to: (this.lastEffectiveOn != null && this.lastEffectiveOn != "") ? new Date(this.lastEffectiveOn) : null,
                
                        },
                        status: new EVCStationBayStatus(this.status, ""),
                        
                    }
                    );
                    this.totalRecords = result.total;
                    this.chargerInstalls = result.fetched;
                    (this.pagesList = new PaginationUtils().getPagesList(
                    this.totalRecords,
                    this.pageRecords,
                    this.pageNo
                    )),
                    (this.totalPages = new PaginationUtils().getTotalPages(
                        this.totalRecords,
                        this.pageRecords
                    ));
                    this.norecordsfound = false;
                    this.loaderTab = false;
                    new ToastUtils().presentToast("Search completed");
                } catch(error) {
                    this.loaderTab = false;
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }
            }
        },
        areFiltersEqual(a, b) {
            return JSON.stringify(a) === JSON.stringify(b);
        },
        async loadPage(page) {
            try {
                localStorage.setItem("installationPage", page);
                this.loaderTab = true;
                this.pageNo = page;
                this.pagesList = new PaginationUtils().getPagesList(
                    this.totalRecords,
                    this.pageRecords,
                    page
                );

                let result = await new EVCStationService().baysAtPageByPaginatedWithSizeMatchingQuery(
                    this.pageNo,
                    this.pageRecords,
                    this.stationId != "" ? this.stationId : "",
                    {
                    station: { name: this.stationName },
                    charger: { id: this.serialNumber },
                    chargerType: new EVChargerType(this.chargerType),
                    effectiveBetween: {
                        // from: this.effectiveOn ? new Date(this.effectiveOn) : null,
                        // to: this.lastEffectiveOn ? new Date(this.lastEffectiveOn) : null,
                        from: (this.effectiveOn != null && this.effectiveOn != "") ? new Date(this.effectiveOn) : null,
                        to: (this.lastEffectiveOn != null && this.lastEffectiveOn != "") ? new Date(this.lastEffectiveOn) : null,
                
                    },
                    status: new EVCStationBayStatus(this.status, ""),
                    }
                );
                this.totalRecords = result.total;
                this.chargerInstalls = result.fetched;
                this.loaderTab = false;
            } catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },
    },
})
</script>